import PropTypes from 'prop-types'
import themable from './_themable'

const Props = {
  children: PropTypes.node
}

export const RequestAccess = themable('RequestAccess', Props)
export default RequestAccess